import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';

import FamilyPlazaTopSection from '../../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../../components/family-plaza/FamilyPlazaSubHeading';
import PaymentInquiry from '../../../../services/FamilyPlaza/PaymentInquiry';

const ManagementFeeInquiryResultsMobile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleNavigation = (route) => { navigate(route); };

  // State for management fee data
  const [feeData, setFeeData] = useState(null);
  const [birthDate, setBirthDate] = useState('');
  const [loading, setLoading] = useState(true);

  // Load management fee data from API using goinId from navigation state
  useEffect(() => {
    const loadFeeData = async () => {
      try {
          let paramData = {};
          const goinId = location.state?.goinId;
          const birthday = location.state?.birthday;
  
          if (goinId) {
             paramData = {
              goinId: goinId,
              birthday: birthday,
              mode: 1,
            }
          } else if(location.state?.enshrineName && location.state?.deceasedName) {
             paramData = {
              goinId: location.state?.goinIdMode2,
              birthday: location.state?.birthdayMode2,
              mode: 2,
            }
          }
            const response = await PaymentInquiry.getFeePaymentInfo(paramData);
          if (response) {
            const mappedData = {
                deceasedName: response.deceasedInfo.deceasedName, // "이주홍"
                contractorName: response.deceasedInfo.customerName, // ""
                enshrineUnit: response.deceasedInfo.enshrineName, // "다1단3열322"
                firstEnshrineDate: response.deceasedInfo.enshrineDay, // "2022-07-19"
                feeStatus: response.paidFees.length > 0 ? "Paid" : "Unpaid", // Based on the presence of paid fees
                lastPaymentDate: response.paidFees.length > 0 ? response.paidFees[0].receiptDay : "", // "2022-07-19"
                nextPaymentDate: response.paidFees.length > 0 ? response.paidFees[0].endDay : "", // "2027-07-18"
                amount: response.paidFees.length > 0 ? response.paidFees[0].receiptPrice : 0, // 600000
                paymentStatus: response.paidFees.length > 0 ? (response.paidFees[0].paymentFlag === "1" ? "Paid" : "Pending") : "Unpaid", // "Paid"

                // Store the full paidFees array for displaying multiple payment records
                paidFees: response.paidFees || [],

                // Store the full unpaidFees array for displaying multiple unpaid payment records
                unpaidFees: response.unpaidFees || [],

                // Additional fields for detailed view
                managementStartDate: response.paidFees.length > 0 ? response.paidFees[0].startDay : "", // "2022-07-19"
                managementEndDate: response.paidFees.length > 0 ? response.paidFees[0].endDay : "", // "2027-07-18"
                unpaidPaymentDate: response.unpaidFees && response.unpaidFees.length > 0 ? response.unpaidFees[0].receiptDay : "", // First unpaid fee date
                unpaidPaymentAmount: response.unpaidFees && response.unpaidFees.length > 0 ? response.unpaidFees[0].receiptPrice : 0, // First unpaid fee amount
                unpaidStartDate: response.unpaidFees && response.unpaidFees.length > 0 ? response.unpaidFees[0].startDay : "", // First unpaid fee start date
                unpaidEndDate: response.unpaidFees && response.unpaidFees.length > 0 ? response.unpaidFees[0].endDay : "", // First unpaid fee end date

                accountBank: "", // Not provided in the response
                accountNumber: "", // Not provided in the response
                accountHolder: "" // Not provided in the response
              };

            setFeeData(mappedData);
          }
         
      } catch (error) {
        console.error('Error loading fee data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadFeeData();
  }, [location.state?.goinId]);

  


  // Function to handle birth date inquiry for address and phone number
  const handleBirthDateInquiryMode1 = async () => {
    if (!birthDate.trim()) {
      alert('계약자 생년월일을 입력해주세요.');
      return;
    }

    // Validate birth date format (YYYYMMDD)
    const birthDateRegex = /^\d{8}$/;
    if (!birthDateRegex.test(birthDate)) {
      alert('생년월일은 8자리 숫자로 입력해주세요. (예: 19800101)');
      return;
    }

    try {
      const nameCandidates = [
        feeData?.deceasedName,
        location?.state?.deceasedName,
        location?.state?.customerName,
        feeData?.contractorName,
        location?.state?.customerNameMode2,
      ];
      const customerName = nameCandidates.find((name) => typeof name === 'string' && name.trim())?.trim();
      if (!customerName) {
        alert('계약자 정보를 찾을 수 없습니다.');
        return;
      }

      // Call the getAddressAndPhone API
      const response = await PaymentInquiry.getAddressAndPhone({
        mode: 1,
        name: customerName,
        dob: birthDate.trim()
      });

      if (response) {
        // Update fee data with contractor details from API response
        setFeeData(prevData => ({
          ...prevData,
          address: response.address,
          phone: response.phoneCell
        }));

        alert('계약자 정보가 조회되었습니다.');
      } else {
        alert('계약자 정보를 찾을 수 없습니다.');
      }
    } catch (error) {
      console.error('Birth date inquiry error:', error);
      alert('계약자 정보 조회에 실패했습니다. 다시 시도해주세요.');
    }
  };

 
  // --- Birth date inquiry for both Mode1 & Mode2 ---
  const handleBirthDateInquiryStarlightMode2 = async () => {
    if (!birthDate.trim()) {
      alert('계약자 생년월일을 입력해주세요.');
      return;
    }

    let dob = birthDate.trim();
    if (dob.length === 7) dob = '0' + dob;

    const birthDateRegex = /^\d{8}$/;
    if (!birthDateRegex.test(dob)) {
      alert('생년월일은 8자리 숫자로 입력해주세요. (예: 19800101)');
      return;
    }

    try {
      const nameCandidates = [
        feeData?.deceasedName,
        location?.state?.deceasedName,
        location?.state?.customerNameMode2,
        location?.state?.customerName,
        feeData?.contractorName,
      ];
      const name = nameCandidates.find((value) => typeof value === 'string' && value.trim())?.trim();
      if (!name) {
        alert('계약자 정보를 찾을 수 없습니다.');
        return;
      }

      const response = await PaymentInquiry.getAddressAndPhone({
        mode: 2,
        name,
        dob
      });

      // Show alert first
      alert('계약자 정보가 조회되었습니다.');

      // Then update feeData
      setFeeData(prev => ({
        ...prev,
        address: response.address || prev.address,
        phone: response.phoneCell || response.phoneCombined || prev.phone
      }));
    } catch (error) {
      console.error('Birth date inquiry error:', error);
      alert('계약자 정보 조회에 실패했습니다. 다시 시도해주세요.');
    }
  };

  const handleBirthDateInquiry = () => {
    if (location?.state?.enshrineName) {
      handleBirthDateInquiryStarlightMode2();
    } else {
      handleBirthDateInquiryMode1();
    }
  };

  return (
    <div className="management-inquiry-mobile-unique announcement-list-page cyber-info-page-pc">

      <FamilyPlazaTopSection />

      <main className="main-content">

        <FamilyPlazaSubHeading heading="관리비 납부 조회" />


        {/* Contractor Information Form */}
        <>
          <div className="management-inquiry-mobile-content-unique">
            <div className="management-inquiry-mobile-form-container-unique">
              <h3 className="management-inquiry-mobile-form-title-unique">계약자 정보</h3>


              {loading ? (
                <div className="management-inquiry-mobile-loading">로딩중...</div>
              ) : feeData && (
                <div className="management-inquiry-mobile-table-unique">
                  <div className="management-inquiry-mobile-table-row-unique">
                    <div className="management-inquiry-mobile-label-unique">고인명</div>
                    <div className="management-inquiry-mobile-value-unique">{feeData.deceasedName}</div>
                  </div>

                  {/* <div className="management-inquiry-mobile-table-row-unique">
                <div className="management-inquiry-mobile-label-unique">계약자명</div>
                <div className="management-inquiry-mobile-value-unique">{location?.state?.customerName}</div>
              </div> */}
                  {/* <div className="management-inquiry-mobile-table-row-unique">
                    <div className="management-inquiry-mobile-label-unique">계약자명</div>
                    <div className="management-inquiry-mobile-value-unique">
                      {feeData?.contractorName || '-'}
                    </div>
                  </div> */}

                  <div className="management-inquiry-mobile-table-row-unique">
                    <div className="management-inquiry-mobile-label-unique">계약자명</div>
                    <div className="management-inquiry-mobile-value-unique">
                      {location?.state?.customerName || feeData?.contractorName || '-'}
                    </div>
                  </div>

                  <div className="management-inquiry-mobile-table-row-unique">
                    <div className="management-inquiry-mobile-label-unique">안치단</div>
                    <div className="management-inquiry-mobile-value-unique">{feeData.enshrineUnit}</div>
                  </div>

                  <div className="management-inquiry-mobile-table-row-unique">
                    <div className="management-inquiry-mobile-label-unique">최초 안치일</div>
                    <div className="management-inquiry-mobile-value-unique">{feeData.firstEnshrineDate}</div>
                  </div>

                  <div className="management-inquiry-mobile-table-row-unique">
                    <div className="management-inquiry-mobile-label-unique">계약자 생년월일</div>
                    <div className="management-inquiry-mobile-input-section-unique">
                      <div className="management-inquiry-mobile-input-container-unique">
                        <input
                          type="text"
                          className="management-inquiry-mobile-input-unique"
                          placeholder="예) 19800101"
                          value={birthDate}
                          onChange={(e) => setBirthDate(e.target.value)}
                        />
                        <button
                          className="management-inquiry-mobile-search-button-unique"
                          onClick={handleBirthDateInquiry}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>
                      </div>
                      <div className="management-inquiry-mobile-hint-unique">
                        계약자 생년월일을 입력하시면 등록된 주소와 전화번호를 확인하실 수 있습니다.
                      </div>
                    </div>
                  </div>

                  <div className="management-inquiry-mobile-table-row-unique">
                    <div className="management-inquiry-mobile-label-unique">주소</div>
                    <div className="management-inquiry-mobile-value-unique">{feeData.address}</div>
                  </div>

                  <div className="management-inquiry-mobile-table-row-unique">
                    <div className="management-inquiry-mobile-label-unique">전화번호</div>
                    <div className="management-inquiry-mobile-value-unique">{feeData.phone}</div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Payment Details Section */}
          <div className="management-inquiry-mobile-content-unique">
            <div className="management-inquiry-mobile-form-container-unique">
              {/* Notice Section */}
              <div className="management-inquiry-mobile-notice-unique">
                <span className="management-inquiry-mobile-notice-asterisk-unique">※</span>
                계약자 주소 또는 전화번호가 변경되었을 경우, 관리사무실에 알려주시어 올바른 정보를 유지하시기 바랍니다.
                <span className="management-inquiry-mobile-phone-unique">(관리사무실 전화번호: 1599-9442)</span>
              </div>

              {/* Title Section */}
              <div className="management-inquiry-mobile-payment-header-unique">
                <h3 className="management-inquiry-mobile-payment-title-unique">최종 관리비 납부 내역</h3>
                <div className="management-inquiry-mobile-payment-separator-unique"></div>
                <div className="management-inquiry-mobile-payment-date-unique">{new Date().toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
              </div>

              {/* Payment Details Table */}
              <div className="management-inquiry-mobile-payment-table-unique">
                {feeData?.paidFees && feeData.paidFees.length > 0 ? (
                  feeData.paidFees.map((payment, index) => (
                    <div key={index}>
                      <div className="management-inquiry-mobile-payment-row-unique">
                        <div className="management-inquiry-mobile-payment-label-unique">최종 납부일</div>
                        <div className="management-inquiry-mobile-payment-value-unique">{payment.receiptDay || '-'}</div>
                      </div>

                      <div className="management-inquiry-mobile-payment-row-unique">
                        <div className="management-inquiry-mobile-payment-label-unique">최종 납부금액</div>
                        <div className="management-inquiry-mobile-payment-value-unique">{payment.receiptPrice || '-'}</div>
                      </div>

                      <div className="management-inquiry-mobile-payment-row-unique">
                        <div className="management-inquiry-mobile-payment-label-unique">관리 기간</div>
                        <div className="management-inquiry-mobile-payment-value-unique">{payment.startDay} ~ {payment.endDay || '-'}</div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="management-inquiry-mobile-payment-row-unique">
                    <div className="management-inquiry-mobile-payment-label-unique">납부 내역</div>
                    <div className="management-inquiry-mobile-payment-value-unique">납부 내역이 없습니다.</div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Management Fee Arrears Details Section */}
          <div className="management-inquiry-mobile-content-unique">
            <div className="management-inquiry-mobile-form-container-unique">
              {/* Title Section */}
              <div className="management-inquiry-mobile-arrears-header-unique">
                <h3 className="management-inquiry-mobile-arrears-title-unique">관리비 미납(또는 납부 예정) 내역</h3>
                <div className="management-inquiry-mobile-arrears-separator-unique"></div>
                <div className="management-inquiry-mobile-arrears-date-unique">{new Date().toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
              </div>

              {/* Arrears Details Table */}
              <div className="management-inquiry-mobile-arrears-table-unique">
                {feeData?.unpaidFees && feeData.unpaidFees.length > 0 ? (
                  feeData.unpaidFees.map((unpaidFee, index) => (
                    <div key={index}>
                      <div className="management-inquiry-mobile-arrears-row-unique">
                        <div className="management-inquiry-mobile-arrears-label-unique">구분</div>
                        <div className="management-inquiry-mobile-arrears-value-unique">미납</div>
                      </div>

                      <div className="management-inquiry-mobile-arrears-row-unique">
                        <div className="management-inquiry-mobile-arrears-label-unique">최종 납부일</div>
                        <div className="management-inquiry-mobile-arrears-value-unique">{unpaidFee.receiptDay || unpaidFee.startDay || '-'}</div>
                      </div>

                      <div className="management-inquiry-mobile-arrears-row-unique">
                        <div className="management-inquiry-mobile-arrears-label-unique">최종 납부금액</div>
                        <div className="management-inquiry-mobile-arrears-value-unique">{unpaidFee.receiptPrice || unpaidFee.managementPrice || '-'}</div>
                      </div>

                      <div className="management-inquiry-mobile-arrears-row-unique">
                        <div className="management-inquiry-mobile-arrears-label-unique">관리 기간</div>
                        <div className="management-inquiry-mobile-arrears-value-unique">{unpaidFee.startDay} ~ {unpaidFee.endDay || '-'}</div>
                      </div>
                    </div>
                                      ))
                ) : (
                  <div className="management-inquiry-mobile-arrears-row-unique">
                    <div className="management-inquiry-mobile-arrears-label-unique">미납 내역</div>
                    <div className="management-inquiry-mobile-arrears-value-unique">미납 내역이 없습니다.</div>
                  </div>
                )}

                <div className="management-inquiry-mobile-arrears-message-row-unique">
                  <div className="management-inquiry-mobile-arrears-message-unique">
                    {feeData?.unpaidFees && feeData.unpaidFees.length > 0
                      ? '미납 금액이 있습니다. 관리사무실로 문의하세요.'
                      : '납부하실 금액이 없습니다.'
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bank Account Information */}
          <div className="management-inquiry-mobile-content-unique">
           <div className="management-inquiry-mobile-form-container-unique">
             <div className="management-inquiry-mobile-bank-info-unique">
               <div className="management-inquiry-mobile-bank-item-unique">
                 <div className="management-inquiry-mobile-bank-bullet-unique"></div>
                 <span className="management-inquiry-mobile-bank-label-unique">관리비 입금 계좌번호 : </span>
                 <span className="management-inquiry-mobile-bank-name-unique">{feeData?.accountBank || '농협'}</span>
                 <span className="management-inquiry-mobile-bank-number-unique">{feeData?.accountNumber || '243100-51-021581'}</span>
               </div>
               <div className="management-inquiry-mobile-bank-item-unique">
                 <div className="management-inquiry-mobile-bank-bullet-unique"></div>
                 <span className="management-inquiry-mobile-bank-label-unique">예금주 : </span>
                 <span className="management-inquiry-mobile-bank-holder-unique">{feeData?.accountHolder || '(주)강화파라다이스'}</span>
               </div>
             </div>
           </div>
         </div>
        </>
      </main>
    </div>
  );
};

export default ManagementFeeInquiryResultsMobile; 